export default Object.freeze({
  DELETE_ITEM_REQUEST_FAILED_MESSAGE:
    'OOPS! Unable to remove the product from bag, please try again',
  ITEM_MOVED_MESSAGE: 'The product was successfully added to your wishlist',
  ITEM_EXIST_MESSAGE: 'The product is already part of your wishlist',
  MOBILE_PDP_ITEM_ADDED_TO_WISHLIST_MESSAGE: 'This item is moved to your wishlist',
  MOBILE_ITEM_EXIST_MESSAGE: 'This item is already part of your wishlist',
  DESKTOP_PDP_ITEM_ADDED_TO_WISHLIST_MESSAGE: 'This item is moved to your wishlist',
  DESKTOP_PDP_ITEM_EXIST_IN_WISHLIST_MESSAGE: 'This item is already part of your wishlist',
  ITEM_DELIST_MESSAGE: 'Sorry! The product is delisted',
  FAILED_TO_MOVE_MESSAGE_FOR_OUTOFSTOCK_ITEM: 'Sorry! Unable to add the product to your wishlist',
  FAILED_TO_MOVE_MESSAGE_FOR_INSTOCK_ITEM: 'OOPS! Unable to add the product to your wishlist',
  SERVICE_UNAVAILABLE_MESSAGE: 'Oops! Something went wrong, Please try again'
});
